module.exports = __webpack_public_path__ + "static/how-we-do-it-banner-b708da865bf8b19e6a28db21cdb6472e.png";